// @flow

import React from 'react';
import { Button } from 'semantic-ui-react';

const RadioMenu = ({ label, currentValue, menuDesc }) => {
  return (
    <div>
      <div className="ui form">
        <div className="ui field">
          <label className="ui form field">{label}</label>
          <Button.Group>
            {menuDesc &&
              menuDesc.map(item => (
                <Button
                  key={item.value}
                  type="button"
                  active={item.value === currentValue}
                  secondary={item.value === currentValue}
                  onClick={item.handler}
                >
                  {item.label}
                </Button>
              ))}
          </Button.Group>
        </div>
      </div>

    </div>
  );
};

export default RadioMenu;



// WEBPACK FOOTER //
// ./src/shared/components/RadioMenu.js